/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { StaticImage } from 'gatsby-plugin-image';
import Button from '../Button';
import Modal from '../Modal';

const ns = `UK-modal`;

function UKModal() {
	const [visible, setVisibility] = useState(false);

	useEffect(() => {
		if (localStorage.getItem('UK')) return;

		const { countryIso } = JSON.parse(localStorage.getItem('bb_distributor')) || {};
		if (countryIso) {
			if (countryIso === 'GB') {
				setTimeout(() => setVisibility(true), 100);
				localStorage.setItem('UK', 1);
				return;
			}
			return;
		}

		fetch(process.env.GATSBY_BB_LOCATION_API_URL)
			.then(res => res.json())
			.then(({ country_iso: countryCode }) => {
				if (countryCode === 'GB') {
					setVisibility(true);
					localStorage.setItem('UK', 1);
				}
			});
	}, []);

	function closeModal() {
		setVisibility(false);
	}

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<Modal
			variant={'custom'}
			isOpen={visible}
			onRequestClose={closeModal}
			whiteCloseButton
		>
			<div className={rootClassnames}>
				<div className={`${ ns }__container`}>
					<StaticImage
						className={`${ ns }__img`}
						src={'https://s3.amazonaws.com/s3.pilates.com/img/uk@2x.jpg'}
						alt={'In-use photo of people on Reformers'}
						loading={'eager'}
					/>
					<div className={`${ ns }__body`}>
						<div className={`${ ns }__body-main`}>
							<h2 className={`${ ns }__title`}>Are you in the UK?</h2>
							<StaticImage
								className={`${ ns }__body-flag`}
								src={'https://s3.amazonaws.com/s3.pilates.com/img/uk-flag@2x.png'}
								alt={'UK flag icon'}
								loading={'eager'}
							/>
						</div>
						<p className={`${ ns }__sub-title`}>
							Visit our UK Warehouse Site to see what&lsquo;s available now.
							<br />
							You save time and $$$ by ordering equipment in our UK Warehouse!
						</p>
						{/* eslint-disable-next-line */}
						<div
							role={'button'}
							className={`${ ns }__btns`}
							onClick={e => e.target !== e.currentTarget && closeModal()}
						>
							<Button
								withArrow
								variant={`white`}
								type={'button'}
							>
								No Thanks
							</Button>
							<a
								href={'https://balancedbodyequipment.uk/'}
								target={'_blank'}
								rel={'noreferrer noopener'}
							>
								<Button
									withArrow
									type={'button'}
								>
									Take Me There!
								</Button>
							</a>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}

export default UKModal;
